import { initCurrentMedia } from 'redux/currentMedia/actions'
import { initNavigation } from 'redux/navigation/actions'
import { INIT_MEDIA_LIST } from 'redux/mediaList/actions'
import { getGroupIndex } from 'redux/navigation/selectors'
import { getMediaList } from 'redux/mediaList/selectors'

export function applyStateFromHistory(state) {
    return function applyStateFromHistory(dispatch, getState) {

        const pushToHistory = false
        const groupIndex = getGroupIndex(getState())

        dispatch(initCurrentMedia(state.currentMedia, pushToHistory))
        dispatch(initNavigation(state.navigation))

        if(getGroupIndex(state) !== groupIndex)
        {
            return dispatch({type: INIT_MEDIA_LIST, mediaList: getMediaList(getState())})
        }
    }
}
